import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { XenaClient } from 'src/app/services';
import { IUser, IUserMembership } from 'src/app/xena-api/dtos';
import { IListOptionsFilter, IQueryStringFilter, defaultListOptionsFilter, defaultQueryStringFilter } from 'src/app/xena-api/filters';
import { Page } from 'src/app/xena-api/response-types';

@Injectable({
  providedIn: 'root'
})
export class SupportService {

  constructor(private xenaClient: XenaClient) { }

  listUsers(filter: IQueryStringFilter = defaultQueryStringFilter): Observable<Page<IUser>> {
    const resourcePath: string = '/XenaAdmin/User';
    return this.xenaClient.list<IUser, IQueryStringFilter>(resourcePath, filter);
  }

  listUserMemberships(userId: number, filter: IListOptionsFilter = defaultListOptionsFilter): Observable<Page<IUserMembership>> {
    const resourcePath: string = `/XenaAdmin/User/${userId}/Membership`;
    return this.xenaClient.list<IUserMembership, IListOptionsFilter>(resourcePath, filter);
  }
}

